import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { T, alpha } from './poyais-ui/theme';

const API = (window as any).ENV_API_URL || 'https://app.poyaisone.com/api/v1';

function LogoHeader() {
  return (
    <div style={{ textAlign: 'center', marginBottom: 28 }}>
      <img src="/poyais-halka.png" width={52} height={52} alt="Poyais One"
        style={{ display: 'inline-block' }} />
      <div style={{ color: T.accent, fontSize: 11, fontWeight: 700,
        letterSpacing: 3, marginTop: 8, textTransform: 'uppercase' as const }}>
        Poyais One
      </div>
    </div>
  );
}

export default function VerifyEmailPage() {
  const params = new URLSearchParams(window.location.search);
  const token  = params.get('token') || '';

  const [status, setStatus] = useState<'loading'|'ok'|'error'>('loading');
  const [message, setMessage] = useState('');

  useEffect(() => {
    if (!token) { setStatus('error'); setMessage('Doğrulama bağlantısı geçersiz.'); return; }
    axios.get(`${API}/auth/verify/${token}`)
      .then(r => { setStatus('ok'); setMessage(r.data?.message || 'E-posta adresiniz doğrulandı.'); })
      .catch(e => { setStatus('error'); setMessage(e.response?.data?.detail || 'Doğrulama başarısız oldu.'); });
  }, [token]);

  const bg: React.CSSProperties = {
    minHeight: '100vh',
    background: `linear-gradient(135deg,${T.ink} 0%,#2a2d2e 50%,${T.ink} 100%)`,
    display: 'flex', alignItems: 'center', justifyContent: 'center',
    padding: '24px 16px', fontFamily: 'Manrope, sans-serif',
  };
  const kart: React.CSSProperties = {
    background: T.surface, borderRadius: 20, padding: '40px 36px',
    width: '100%', maxWidth: 440, boxShadow: '0 20px 60px rgba(0,0,0,0.3)',
  };

  return (
    <div style={bg}>
      <div style={kart}>
        <LogoHeader />
        {status === 'loading' && (
          <div style={{ textAlign: 'center', padding: '8px 0 24px' }}>
            <div style={{ width: 32, height: 32, border: `3px solid ${T.accent}`, borderTopColor: 'transparent',
              borderRadius: '50%', margin: '0 auto 16px', animation: 'spin 0.8s linear infinite' }} />
            <style>{`@keyframes spin{to{transform:rotate(360deg)}}`}</style>
            <p style={{ fontSize: 14, color: 'var(--py-text-mid-alt)' }}>Doğrulanıyor...</p>
          </div>
        )}
        {status === 'ok' && (
          <div style={{ textAlign: 'center', padding: '8px 0 24px' }}>
            <div style={{ fontSize: 52, marginBottom: 16 }}>✅</div>
            <h2 style={{ fontSize: 20, fontWeight: 800, color: T.text, margin: '0 0 10px' }}>E-postanız Doğrulandı!</h2>
            <p style={{ fontSize: 14, color: 'var(--py-text-mid-alt)', margin: '0 0 24px', lineHeight: 1.7 }}>{message}</p>
            <a href="/dashboard" style={{ display: 'inline-block', padding: '12px 28px', background: T.accent,
              color: T.accentInk, borderRadius: 10, fontSize: 14, fontWeight: 700, textDecoration: 'none' }}>
              Panele Git →
            </a>
          </div>
        )}
        {status === 'error' && (
          <div style={{ background: 'var(--py-red-tint)', border: `1px solid ${alpha(T.red, 25)}`, borderRadius: 10, padding: '20px 24px', textAlign: 'center' }}>
            <div style={{ fontSize: 36, marginBottom: 10 }}>⚠️</div>
            <h2 style={{ fontSize: 18, fontWeight: 700, color: T.text, margin: '0 0 8px' }}>Doğrulama Başarısız</h2>
            <p style={{ fontSize: 14, color: 'var(--py-text-mid-alt)', margin: 0 }}>{message}</p>
          </div>
        )}
      </div>
    </div>
  );
}
